module.exports = __webpack_public_path__ + "macao.svg?ebf1ee3ae060722caf5595c83adad691";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/countries/svg/macao.svg
// module id = 218
// module chunks = 10